<template>
  <div
    style="height: 90vh; width: 90vw; position: relative; z-index: 999"
    class="d-flex flex-column align-items-center"
  >
    <div
      style="
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      "
    >
      <div class="white--text" v-if="loader">
        Loading...
        <v-progress-linear v-model="progress" color="white"></v-progress-linear>
      </div>
    </div>
    <button style="position: absolute; top: 25px; right: 25px; z-index: 99">
      <img
        @click="$emit('close')"
        src="@/assets/icons/Close Button.svg"
        style="height: 23px; width: auto"
      />
    </button>

    <model-fbx
      style="height: 60vh; width: auto"
      @on-progress="onProgress"
      @on-load="onLoading"
      backgroundColor="#262626"
      :src="`https://chalkidiki.mobics.gr/video/${currentModel.video.file_name}`"
      :scale="{ x: 0.6, y: 0.6, z: 0.6 }"
      :rotation="
        currentModel.video_id == 489
          ? { x: 0, y: 0, z: 0 }
          : { x: 5, y: 0, z: 0 }
      "
      :lights="[
        {
          type: 'AmbientLight',
          position: { x: 1, y: 1, z: 1 },
          color: 0xffffff,
          intensity: 1,
        },
        {
          type: 'PointerLight',
          position: { x: 1, y: 1, z: 1 },
          color: 0xffffff,
          intensity: 1,
        },
      ]"
      :controlsOptions="{ enablePan: false }"
    ></model-fbx>

    <div class="model-text flex-grow-1 d-flex flex-column align-center">
      <div
        class="white--text text-center"
        style="font-weight: 400; font-size: 18px; width: 80%"
      >
        {{ currentModel.video.name }}
      </div>
      <v-divider width="80%" class="white mt-3 mb-5"> </v-divider>
      <div
        v-html="currentModel.video.description"
        class="white--text text-center"
        style="font-weight: 300; width: 80%"
      ></div>

      <div
        v-if="model.length > 1"
        class="d-flex align-center justify-center py-4"
      >
        <v-btn
          class="mr-2"
          @click="onPrevModel"
          :disabled="currentModelIndex == 0"
        >
          <v-icon> mdi-arrow-left </v-icon>
        </v-btn>

        <v-btn
          @click="onNextModel"
          :disabled="currentModelIndex == model.length - 1"
        >
          <v-icon> mdi-arrow-right </v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { ModelFbx } from "vue-3d-model";
export default {
  components: {
    ModelFbx,
  },
  props: {
    model: Array,
  },

  created() {
    this.currentModel = this.model[0];
    this.currentModelIndex = 0;
  },
  // console.log()
  data() {
    return {
      loader: true,
      progress: 0,
      currentModel: null,
      currentModelIndex: null,
    };
  },

  methods: {
    onProgress(e) {
      this.progress = (e.total / e.loaded) * 100;
      // console.log("this.progress", this.progress);
    },

    onLoading(object) {
      this.loader = true;
      console.log("loaded", object);

      this.loader = false;
    },

    onPrevModel() {
      if (this.currentModelIndex != 0) {
        this.currentModel = this.model[this.currentModelIndex - 1];
        this.currentModelIndex = this.currentModelIndex - 1;
        console.log("?");
      }
    },

    onNextModel() {
      if (this.currentModelIndex != this.model.length - 1) {
        this.currentModel = this.model[this.currentModelIndex + 1];
        this.currentModelIndex = this.currentModelIndex + 1;
        console.log("?");
      }
    },
  },
};
</script>

<style>
.model-text {
  background-color: #262626;
}
canvas {
  width: 100% !important;
  height: 100% !important;
}
</style>
